import { TableCell } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { makeStyles } from "@mui/styles";
import { Row } from "@tanstack/react-table";
import React from "react";

interface Props<T> {
    row: Row<T>;
}

const useStyles = makeStyles(() => ({
    checkbox: {
        padding: 0
    },
    cell: {
        whiteSpace: "nowrap",
        padding: "0px 8px",
        textAlign: "center"
    }
}));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const QATableSelectionBody: React.FC<Props<any>> = props => {
    const classes = useStyles();

    return (
        <TableCell className={classes.cell}>

            <Checkbox
                checked={props.row.getIsSelected()}
                onChange={props.row.getToggleSelectedHandler()}
                className={classes.checkbox}
                disableFocusRipple
                disableTouchRipple
                disableRipple
                color="primary" />

        </TableCell>
    );
};

export default QATableSelectionBody;
